module.exports = __webpack_public_path__ + "img/subscribed.548ac433.png";